import { Environments } from "./environments";

export const environment = {
  deployment: Environments.staging,
  version: "1.6.1 (1)",
  voucherDebug: false,
};
